export const DAG_WALK_QUEUE_CONCURRENCY = 1;
/**
 * The multicodec code for dag-pb binary data
 */
export const DAG_PB_CODEC_CODE = 0x70;
/**
 * The multicodec code for raw binary data
 */
export const RAW_PB_CODEC_CODE = 0x55;
//# sourceMappingURL=constants.js.map